const SET_MAINTENANCE_DATA = 'myhealth/SET_MAINTENANCE_DATA';
const SET_CAUTIONS_DATA = 'myhealth/SET_CAUTIONS_DATA'
const SET_COMPONENTTRACKING_DATA = 'myhealth/SET_COMPONENTTRACKING_DATA'
const SET_COMPONENTTRACKING_FILTER = 'myhealth/SET_COMPONENTTRACKING_FILTER'
const SET_SELECTEDMR_DATA = 'myhealth/SET_SELECTEDMR_DATA'

export {
    SET_MAINTENANCE_DATA,
    SET_CAUTIONS_DATA,
    SET_COMPONENTTRACKING_DATA,
    SET_COMPONENTTRACKING_FILTER,
    SET_SELECTEDMR_DATA
};
